/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OperationTypeEnum,
    OperationTypeEnumFromJSON,
    OperationTypeEnumFromJSONTyped,
    OperationTypeEnumToJSON,
} from './OperationTypeEnum';
import {
    PersonalAssetMetaDataDto,
    PersonalAssetMetaDataDtoFromJSON,
    PersonalAssetMetaDataDtoFromJSONTyped,
    PersonalAssetMetaDataDtoToJSON,
} from './PersonalAssetMetaDataDto';

/**
 * 
 * @export
 * @interface PersonalAssetHistoryWithCumulativeDto
 */
export interface PersonalAssetHistoryWithCumulativeDto {
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    personalAssetId: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    date: Date;
    /**
     * 
     * @type {PersonalAssetMetaDataDto}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    metaData?: PersonalAssetMetaDataDto;
    /**
     * 
     * @type {OperationTypeEnum}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    operationType: OperationTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    cumulativeValue: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetHistoryWithCumulativeDto
     */
    note?: string | null;
}

export function PersonalAssetHistoryWithCumulativeDtoFromJSON(json: any): PersonalAssetHistoryWithCumulativeDto {
    return PersonalAssetHistoryWithCumulativeDtoFromJSONTyped(json, false);
}

export function PersonalAssetHistoryWithCumulativeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetHistoryWithCumulativeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
        'personalAssetId': json['personalAssetId'],
        'date': (new Date(json['date'])),
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetMetaDataDtoFromJSON(json['metaData']),
        'operationType': OperationTypeEnumFromJSON(json['operationType']),
        'cumulativeValue': json['cumulativeValue'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function PersonalAssetHistoryWithCumulativeDtoToJSON(value?: PersonalAssetHistoryWithCumulativeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
        'personalAssetId': value.personalAssetId,
        'date': (value.date.toISOString()),
        'metaData': PersonalAssetMetaDataDtoToJSON(value.metaData),
        'operationType': OperationTypeEnumToJSON(value.operationType),
        'cumulativeValue': value.cumulativeValue,
        'note': value.note,
    };
}

